module.exports = __webpack_public_path__ + "img/cnp-partners.3e8237dd.png";